import { Tab, Tabs } from "@material-ui/core";
import { useQueryParam } from "use-query-params";

import { Activity } from "../activity";
import { Overview } from "../overview";
import { Results } from "../results";

const VALID_TABS = ["overview", "activity", "results"];

export function DiagnosisTabs() {
  const [tab, setTab] = useQueryParam("tab");
  const activeTab = VALID_TABS.includes(tab) ? tab : "overview";

  return (
    <div className="flex w-full flex-col">
      <div className="flex overflow-hidden rounded-md bg-white shadow-[0_6px_20px_rgb(0_0_0_/_10%)]">
        <Tabs
          value={activeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          onChange={(_, value) => setTab(value)}
          aria-label="Seções do diagnóstico CRM Pet"
          style={{ flex: 1 }}
        >
          <Tab label="Visão geral" value="overview" />
          <Tab label="Atividade" value="activity" />
          <Tab label="Resultados" value="results" />
        </Tabs>
      </div>

      <div className="pt-5">
        {activeTab === "overview" && <Overview />}
        {activeTab === "activity" && <Activity />}
        {activeTab === "results" && <Results />}
      </div>
    </div>
  );
}
